//utils
import zeroPadding from 'utils/zeroPadding';
import { isAfterFourPM } from 'utils/isafterfourpm';

import {
    UPDATE_DETAIL_DROP_DOWN,
    UPDATE_DETAIL_DATE_RANGE,
    GET_DETAIL_RON_SITES,
    GET_DETAIL_COUNTRIES,
    GET_DETAIL_EMBEDS,
    GET_DETAIL_STORIES,
    GET_DETAIL_STORY_CLICKS,
    GET_DETAIL_STORY_CLICKS_FETCHING,
    GET_DETAIL_QUESTIONS_ANSWERED,
    GET_DETAIL_TOP_QUESTIONS_ANSWERED,
    GET_DETAIL_AVERAGE_IN_VIEW,
    GET_DETAIL_UNIQUE_ENGAGED_USERS,
    GET_DETAIL_QUESTIONS_ANSWERED_FETCHING,
    GET_DETAIL_TOP_QUESTIONS_ANSWERED_FETCHING,
    GET_DETAIL_AVERAGE_IN_VIEW_FETCHING,
    GET_DETAIL_UNIQUE_ENGAGED_USERS_FETCHING,
    GET_DETAIL_CPM, GET_DETAIL_REVENUE,
    GET_TOP_STORY_CLICKS, GET_TOP_STORY_CLICKS_FETCHING,
    GET_DETAIL_IMPRESSION, DETAIL_REVENUE_FETCHING,
    CLEAR_DETAIL_STATE
} from 'state/actions/detailViewState/detailViewStatus';
import { CLEAR_ALL_STATES } from 'state/actions/auth_status';

//helpers

const populateTopItems = (data) =>{
    const topItems = [];
    //this will check if each piece of data contains an id or if it is already included in top items before pushing item in to array
    Object.keys(data).forEach(item => !data[item].id || topItems.includes(data[item].id) ? null : topItems.push(data[item].id));
    return topItems;
};

const generateDefaultStartDate = () => {
    let week = new Date(new Date() - (1000 * 60 * 60 * 24 * 7));
    return `${week.getFullYear()}-${zeroPadding((week.getMonth() + 1), 2)}-${zeroPadding(week.getDate(), 2)}`;
};

const generateDefaultEndDate = () => {
    let today = new Date(new Date() - (isAfterFourPM() ? (1000 * 60 * 60 * 24) : (1000 * 60 * 60 * 24 * 2)));
    return `${today.getFullYear()}-${zeroPadding((today.getMonth() + 1), 2)}-${zeroPadding(today.getDate(), 2)}`;
};


const getDefaultState = () => ({
    ronSites: {},
    ronSitesReceived: false,
    selectedSites: [],
    stories: {},
    selectedStories: [],
    devices: ['MOBILE', 'DESKTOP'],
    selectedDevices: [],
    countries: {},
    countriesReceived: false,
    selectedCountries: [],
    embeds: {},
    embedsReceived: false,
    selectedEmbeds: [],
    dateRange: {
        from: generateDefaultStartDate(),
        to: generateDefaultEndDate()
    },
    averageInViewDetail: {},
    averageInViewDetailFetching: false,
    uniqueEngagedUsersDetail: {},
    uniqueEngagedUsersDetailFetching: false,
    topQuestionsAnsweredDetail: [],
    topQuestionsAnsweredDetailFetching: false,
    questionsAnsweredDetail:{},
    questionsAnsweredDetailFetching: false,
    topStoryClicks: [],
    topStoryClicksFetching: false,
    storyClicks: {},
    storyClicksFetching: false,
    cpmDetail: {},
    revenueDetail: {},
    impressionDetail: {},
    fetchingRevenue: false
});

const selectItems = itemType =>{
    switch (itemType) {
        case 'SITE':
        case 'AD_TYPE':
        case 'AD_UNIT':
            return 'selectedSites';
        case 'DEVICE':
            return 'selectedDevices';
        case 'GEO':
            return 'selectedCountries';
        case 'EMBED':
            return 'selectedEmbeds';
        case 'STORY':
            return 'selectedStories';
        default:
            break;
    }
};



let detailData = (state = getDefaultState(), action) => {
    let newState = JSON.parse(JSON.stringify(state));

    switch (action.type) {

        case GET_DETAIL_RON_SITES:
            newState.ronSites = action.data;
            newState.ronSitesReceived = true;
            return newState;
        case GET_DETAIL_COUNTRIES:
            newState.countries = action.data;
            newState.countriesReceived = true;
            return newState;
        case GET_DETAIL_EMBEDS:
            newState.embeds = action.data;
            newState.embedsReceived = true;
            return newState;
        case GET_DETAIL_STORIES:
            newState.stories = action.stories;
            return newState;
        case UPDATE_DETAIL_DROP_DOWN:
         newState[selectItems(action.itemType)] = action.items;
         return newState;
        case UPDATE_DETAIL_DATE_RANGE:
            newState.dateRange = action.dateRange;
            return newState;
        case GET_DETAIL_QUESTIONS_ANSWERED:
            newState.questionsAnsweredDetail = action.data;
            if(action.topRank) newState[selectItems(action.viewType)] = populateTopItems(action.data);
            return newState;
        case GET_DETAIL_QUESTIONS_ANSWERED_FETCHING:
            newState.questionsAnsweredDetail = {};
            newState.questionsAnsweredDetailFetching = action.bool;
            return newState;
        case GET_DETAIL_TOP_QUESTIONS_ANSWERED:
            newState.topQuestionsAnsweredDetail = action.data;
            newState.topQuestionsAnsweredDetailFetching = false;
            return newState;
        case GET_DETAIL_TOP_QUESTIONS_ANSWERED_FETCHING:
            newState.topQuestionsAnsweredDetail = {};
            newState.topQuestionsAnsweredDetailFetching = action.bool;
            return newState;
        case GET_DETAIL_AVERAGE_IN_VIEW:
            newState.averageInViewDetail = action.data;
            if(action.topRank) newState[selectItems(action.viewType)] = populateTopItems(action.data);
            return newState;
        case GET_DETAIL_AVERAGE_IN_VIEW_FETCHING:
            newState.averageInViewDetail = {};
            newState.averageInViewDetailFetching = action.bool;
            return newState;
        case GET_TOP_STORY_CLICKS:
            newState.topStoryClicks = action.data;
            return newState;
        case GET_TOP_STORY_CLICKS_FETCHING:
            newState.topStoryClicksFetching = action.status;
            return newState;
        case GET_DETAIL_STORY_CLICKS:
            newState.storyClicks = action.data;
            if(action.topRank) newState[selectItems(action.viewType)] = populateTopItems(action.data);
            return newState;
        case GET_DETAIL_STORY_CLICKS_FETCHING:
            newState.storyClicksFetching = action.status;
            return newState;
        case GET_DETAIL_UNIQUE_ENGAGED_USERS:
            newState.uniqueEngagedUsersDetail = action.data;
            newState.uniqueEngagedUsersDetailFetching = false;
            if(action.topRank) newState[selectItems(action.viewType)] = populateTopItems(action.data);
            return newState;
        case GET_DETAIL_UNIQUE_ENGAGED_USERS_FETCHING:
            newState.uniqueEngagedUsersDetail = {};
            newState.uniqueEngagedUsersDetailFetching = action.bool;
            return newState;
        case GET_DETAIL_CPM:
            newState.cpmDetail = action.data;
            newState.fetchingRevenue = false;
            if(action.topRank) newState[selectItems(action.viewType)] = populateTopItems(action.data);
            return newState;
        case GET_DETAIL_IMPRESSION:
            newState.impressionDetail = action.data;
            newState.fetchingRevenue = false;
            if(action.topRank) newState[selectItems(action.viewType)] = populateTopItems(action.data);
            return newState;
        case GET_DETAIL_REVENUE:
            newState.revenueDetail = action.data;
            if(action.topRank) newState[selectItems(action.viewType)] = populateTopItems(action.data);
            return newState;
        case DETAIL_REVENUE_FETCHING:
            newState.revenueDetail = {};
            newState.impressionDetail = {};
            newState.cpmDetail = {};
            newState.fetchingRevenue = action.bool;
            return newState;
        case CLEAR_ALL_STATES:
        // fall though
        case CLEAR_DETAIL_STATE:
            newState = getDefaultState();
            return newState;
        default:
            return newState;
    }
};


export default detailData;